<script lang="ts">
    import {ProjectFinancialOverviewService} from 'src/features/erp-sutor/features/project-financial-overview';
    import type {Rec} from 'src/typings';
    import {getInjector} from 'src/core';
    import KpBarebonesTable from 'shared/ui-widgets/table/barebones/KpBarebonesTable.svelte';
    import FinancialOverviewProjectItem from './ProjectFinancialOverviewItem.svelte';
    import {onMount} from 'svelte';
    import type {ProjectFinancialOverviewResponse} from 'src/features/erp-sutor/features/project-financial-overview/types';
    import KpLoadingInline from 'shared/components/kp-loading/KpLoadingInline.svelte';

    export let projectRecord: Rec;

    const service = getInjector().getByClass(ProjectFinancialOverviewService);
    let projectFinancialOverviewLoading = true;
    let projectFinancialOverview: ProjectFinancialOverviewResponse;

    onMount(async () => {
        projectFinancialOverview = await service.getFinancialOverview(projectRecord);
        projectFinancialOverviewLoading = false;
    });
</script>

<KpBarebonesTable additionalClasses="project-financial-overview-table" fontSize="13px" rowsTopBordered>
    <tr slot="header">
        <th>Zakázka</th>
        <th></th>
        <th class="align-end">Práce (z výkazů)</th>
        <th class="align-end">Stroj s obsluhou (z výkazů)</th>
        <th class="align-end">Stroj (z výkazů)</th>
        <th class="align-end">Dílo (z výkazů)</th>
        <th class="align-end">Materiál (z výkazů)</th>
        <th class="align-end">Subka (z výkazů)</th>
        <th class="align-end">Přeúčtováné (z výkazů)</th>
        <th class="align-end">Materiál (z pohody)</th>
        <th class="align-end">Subka (z pohody)</th>
        <th class="align-end">Ostatní (z pohody)</th>
        <th class="align-end">Plánovaný náklad</th>
        <th class="align-end">Plánovaný výnos</th>
        <th class="align-end">Plánovaný zisk</th>
        <th class="align-end">Realný náklad</th>
        <th class="align-end">Realný výnos</th>
        <th class="align-end">Realný zisk</th>
    </tr>

    <svelte:fragment slot="body">
        {#if projectFinancialOverviewLoading}
            <KpLoadingInline size="xs"/>
        {:else}
            <FinancialOverviewProjectItem index={0} {projectFinancialOverview}/>
        {/if}
    </svelte:fragment>
</KpBarebonesTable>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    :global {
        .project-financial-overview-table {
            th.align-end {
                text-align: end !important;
            }
        }
    }
</style>